<bca-product-dialog
  (productSelected)="onProductSelected($event)"
  (closeProductDialog)="closeProductDialog()"
></bca-product-dialog>
<bca-choose-route-dialog
  (onRouteSelected)="onCloseRouteDialog()"
></bca-choose-route-dialog>
<div>
  <div>
    <div class="tile__title">
      <nes-heading
        tag="h1"
        size="6xl"
        [cypress]="'page_title'"
        class="nes-mb-3"
      >
        {{ "COMPOSE.PRODUCTS_OVERVIEW.TITLE_INFORMAL" | translate }}
      </nes-heading>
      <nes-text class="nes-mb-5">{{
        "COMPOSE.PRODUCTS_OVERVIEW.GENERAL_CHECKLIST_LABEL" | translate
      }}</nes-text>

      <div class="richText mb-3">
        <nes-text-list
          list-type="unordered"
          size="base"
          color="text-body"
          class="nes-mb-2"
        >
          <nes-text-list-item
            *ngFor="
              let item of 'COMPOSE.PRODUCTS_OVERVIEW.GENERAL_CHECKLIST'
                | translate
            "
            ><span [innerHTML]="item"></span
          ></nes-text-list-item>
        </nes-text-list>
      </div>
      <nes-heading
      tag="h2"
      size="2xl"
      [cypress]="'page_title'"
      class="nes-mb-3"
    >
      {{ "COMPOSE.PRODUCTS_OVERVIEW.COMPOSE_INFO_TITLE" | translate }}
    </nes-heading>

      <div class="richText mb-3">
        <nes-text-list
          list-type="unordered"
          size="base"
          color="text-body"
          class="nes-mb-2"
        >
          <nes-text-list-item
            *ngFor="
              let item of 'COMPOSE.PRODUCTS_OVERVIEW.COMPOSE_INFO_CHECKLIST'
                | translate
            "
            ><span [innerHTML]="item"></span
          ></nes-text-list-item>
        </nes-text-list>
      </div>

      <div *ngIf="productsLoading$ | async; else products">
        <app-products-overview-skeleton></app-products-overview-skeleton>
      </div>
    </div>
    <div class="tile__content">
      <section>
        <ng-template #products>
          <ng-container>
            <div class="nes-flex nes-flex-col nes-gap-5 nes-mb-5">
              <ng-container
                *ngFor="
                  let product of allProducts$ | async;
                  trackBy: trackByProductIdentifier
                "
              >
                <div class="nes-h-full">
                  <bca-product-card
                    [id]="product.identifier"
                    [cypress]="product.identifier"
                    [showNewProductLayout]="!showNewProductLayout"
                    [isMobileView]="mobileQueryMatches$ | async"
                    [hideSticker]="hideSticker$ | async"
                    [isSelected]="
                      (selectedProduct$ | async)?.identifier ===
                      product.identifier
                    "
                    [isPreSelected]="product | preSelected | async"
                    [routeLoading]="routeLoading$ | async"
                    [product]="product"
                    [configuredProduct]="
                      product.identifier === ProductIdentifier.Traject
                        ? (configuredProduct$ | async)
                        : null
                    "
                    (selected)="onProductSelected($event)"
                    (chooseRoute)="onRouteDialogOpened()"
                    (readMore)="onReadMoreOpened($event)"
                  ></bca-product-card>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-template>
      </section>
    </div>
  </div>
  <ng-container *ngIf="!(productsLoading$ | async)">
    <ng-container *ngIf="selectedProduct$ | async as selectedProduct">
      <bca-choose-extras
        (addProduct)="addNewProduct()"
        (nextPage)="nextRoute()"
        [selectedProduct]="selectedProduct"
      >
      </bca-choose-extras>
    </ng-container>
  </ng-container>
</div>
